import type { Theme } from '@mui/material/styles';
import type { Components } from '@mui/material/styles';

export const MuiSvgIcon = (theme: Theme): Components => ({
  MuiSvgIcon: {
    styleOverrides: {
      colorPrimary: {
        color: theme.palette.primary.main,
      },
      colorSecondary: {
        color: theme.palette.secondary.main,
      },
      colorAction: {
        color: theme.palette.grey[800],
      },
      colorError: {
        color: theme.palette.error.main,
      },
      colorDisabled: {
        color: theme.palette.text.disabled,
      },
      fontSizeInherit: {
        fontSize: 'inherit',
      },
      fontSizeSmall: {
        fontSize: theme.typography.pxToRem(16),
      },
      fontSizeLarge: {
        fontSize: theme.typography.pxToRem(35),
      },
    },
  },
});
